import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { UserPreference } from '@utils/types/user-preferences/user-preferences.ts';

const fetchUserPreferences = async (): Promise<UserPreference> => {
  const { data } = await Axios.get(GET_URL().userPreferences);
  return data;
};

export const useGetUserPreferences = (
  options: Pick<
    UseQueryOptions<UserPreference, AxiosError<BaseError>>,
    'enabled' | 'refetchOnWindowFocus'
  > = {}
) => {
  return useQuery<UserPreference, AxiosError<BaseError>>(
    'userPreferences',
    fetchUserPreferences,
    { staleTime: 1000 * 60 * 5, ...options }
  );
};
